import styled from "styled-components";

export const StyledMeasurePopup = styled.div`
  width: 100%;
`;
